import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';

import './HeadLine.less';

const CNAME = 'HeadLine';

const HeadLine = ({ title }) => (
  <h1 className={cnames(CNAME)}>
    {title.split('#').map((text, index) =>
      <span key={index} className={`${CNAME}__text`}>{text.trim()}</span>
    )}
  </h1>
);

HeadLine.propTypes = {
  title: PropTypes.string.isRequired
};

HeadLine.defaultProps = {
  title: ''
};

export default HeadLine;
